export const MAIN_CLASS_NAME = 'typed-step-modal';
export const CONTENT_CLASS_NAME = `${MAIN_CLASS_NAME}__content`;
export const SECTION_CLASS_NAME = `${CONTENT_CLASS_NAME}__section`;
export const ITEM_CLASS_NAME = `${SECTION_CLASS_NAME}__item`;
export const HTTP_HEADERS_CLASS_NAME = `${ITEM_CLASS_NAME}__http-headers`;
export const TYPE_GRID_CLASS_NAME = `${MAIN_CLASS_NAME}__type-grid`;
export const TYPE_OPTION_CLASS_NAME = `${MAIN_CLASS_NAME}__type-option`;
export const TYPE_OPTION_LABEL_CLASS_NAME = `${TYPE_OPTION_CLASS_NAME}__label`;
export const TYPE_OPTION_TITLE_CLASS_NAME = `${TYPE_OPTION_LABEL_CLASS_NAME}__title`;
